import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-1" }
const _hoisted_2 = { class: "mr-2 text-[10px] uppercase" }
const _hoisted_3 = { class: "flex items-center gap-1" }
const _hoisted_4 = { class: "mr-2 text-[10px] uppercase" }

import { columns } from '@/tables/columns/transactions';
    import { Combobox, DatePicker } from '@/components/ui/form';
    import { getLocalTimeZone, today } from '@internationalized/date';
    import { Head } from '@inertiajs/vue3';
    import { ref, computed, watch } from 'vue';
    import { router } from '@inertiajs/vue3';
    import { Row } from '@tanstack/table-core';
    import { Separator } from '@/components/ui/separator';
    import { usePage } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import { useQuery } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableRefreshButton from '@/components/datatable/DataTableRefreshButton.vue';
    import DataTableToolbarActions from '@/components/datatable/DataTableToolbarActions.vue';
    import PageCard from '@/components/PageCard.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import ThousandSeparatorInput from '@/components/ThousandSeparatorInput.vue';
    import TransferEconomic from '@/components/bank/TransferEconomic.vue';
    import type { SharedData, BreadcrumbItem } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Transactions',
  props: {
    accountsSelect: {},
    dbAccount: {}
  },
  setup(__props: any) {

    const props = __props;

    const { hasPermission, hasAnyPermission } = usePermissions();
    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const accountId = computed({
        get: () => page.props.ziggy.query.account_id,
        set: (newAccountId) => {
            router.visit(route('v2.transactions.index', { account_id: newAccountId }), {
                preserveState: true,
            });
        },
    });

    const startDate = ref(today(getLocalTimeZone()).subtract({ months: 1 }));
    const endDate = ref(today(getLocalTimeZone()));
    const amountFrom = ref(undefined);
    const amountTo = ref(undefined);

    watch(selectedCompanyId, (newCompanyId, oldCompanyId) => {
        if (newCompanyId !== oldCompanyId && oldCompanyId !== undefined) {
            router.visit(route('v2.bank.index'));
        }
    });

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'menu.bank',
            href: route('v2.bank.index'),
        },
        {
            title: 'viia.transactions.page_header',
            href: route('v2.transactions.index'),
        },
    ];

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.TRANSACTIONS, selectedCompanyId, accountId],
        queryFn: getBank,
        refetchOnWindowFocus: false,
    });

    async function getBank() {
        const { data } = await axios.get(route('v2.transactions.all', selectedCompanyId.value), {
            params: {
                account_id: accountId.value,
                transaction_from_date: startDate.value,
                transaction_to_date: endDate.value,
                transaction_from_amount: amountFrom.value,
                transaction_to_amount: amountTo.value,
            },
        });
        return data.data;
    }

    const dataTableRef = ref();

    const selectedRows = computed(() => {
        if (!dataTableRef.value?.table) return [];

        const selectedRowModel = dataTableRef.value.table.getFilteredSelectedRowModel();
        return selectedRowModel.flatRows.map((row: Row<any>) => row.original);
    });

    watch(accountId, (newAccountId, oldAccountId) => {
        if (newAccountId !== oldAccountId && oldAccountId !== undefined) {
            dataTableRef.value?.table.resetRowSelection();
        }
    });

    const canTransferEconomic = computed(() => {
        return hasAnyPermission([
            Permission.BANK_CREATE,
            Permission.BANK_UPDATE,
            Permission.BANK_DELETE,
        ]);
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('viia.header')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, { breadcrumbs: breadcrumbs }, {
      default: _withCtx(() => [
        (_unref(hasPermission)(_unref(Permission).BANK_VIEW) && selectedCompanyId.value)
          ? (_openBlock(), _createBlock(PageCard, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(DataTable, {
                  ref_key: "dataTableRef",
                  ref: dataTableRef,
                  "table-key": _unref(QueryKey).TRANSACTIONS,
                  columns: _unref(columns),
                  data: _unref(data),
                  loading: _unref(isPending),
                  "default-sorting": [{ id: 'date', desc: true }],
                  "default-column-visibility": {
                    select: canTransferEconomic.value,
                }
                }, {
                  title: _withCtx(() => [
                    _createVNode(_unref(Combobox), {
                      modelValue: accountId.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accountId).value = $event)),
                      options: _ctx.accountsSelect,
                      "show-remove-button": false,
                      "content-class": "min-w-sm"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  actions: _withCtx(() => [
                    _createVNode(DataTableToolbarActions, { name: "transactions" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('tables.filters.date_from_to')), 1),
                          _createVNode(_unref(DatePicker), {
                            modelValue: startDate.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((startDate).value = $event))
                          }, null, 8, ["modelValue"]),
                          _cache[5] || (_cache[5] = _createElementVNode("span", null, "-", -1)),
                          _createVNode(_unref(DatePicker), {
                            modelValue: endDate.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((endDate).value = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createVNode(_unref(Separator), {
                          orientation: "vertical",
                          class: "hidden h-2.5! md:flex"
                        }),
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('tables.filters.amount_from_to')), 1),
                          _createVNode(ThousandSeparatorInput, {
                            modelValue: amountFrom.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((amountFrom).value = $event)),
                            class: "w-28",
                            placeholder: _ctx.$t('translations.kr'),
                            "with-decimals": ""
                          }, null, 8, ["modelValue", "placeholder"]),
                          _cache[6] || (_cache[6] = _createElementVNode("span", null, "-", -1)),
                          _createVNode(ThousandSeparatorInput, {
                            modelValue: amountTo.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((amountTo).value = $event)),
                            class: "w-28",
                            placeholder: _ctx.$t('translations.kr'),
                            "with-decimals": ""
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _createVNode(_unref(Separator), {
                          orientation: "vertical",
                          class: "hidden h-2.5! md:flex"
                        }),
                        _createVNode(DataTableRefreshButton, {
                          onRefetch: _unref(refetch),
                          "is-fetching": _unref(isFetching)
                        }, null, 8, ["onRefetch", "is-fetching"]),
                        (canTransferEconomic.value)
                          ? (_openBlock(), _createBlock(TransferEconomic, {
                              key: 0,
                              "selected-company-id": selectedCompanyId.value,
                              "selected-rows": selectedRows.value,
                              "account-id": accountId.value,
                              "db-account": _ctx.dbAccount
                            }, null, 8, ["selected-company-id", "selected-rows", "account-id", "db-account"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["table-key", "columns", "data", "loading", "default-column-visibility"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})